import { StyleSheet, type TextStyle } from 'react-native-web';
import { colors, fontWeights } from '../../../global-styles';

const styles = StyleSheet.create({
  row: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  counter: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  counterValue: {
    width: 30,
    textAlign: 'center',
    fontSize: 16,
    fontWeight: fontWeights.bold as TextStyle['fontWeight'],
    color: colors.brandPrimary,
  },
  counterLabel: {
    fontSize: 16,
    fontWeight: fontWeights.bold as TextStyle['fontWeight'],
    color: colors.brandPrimary,
  },
  label: {
    fontSize: 16,
    color: colors.brandPrimary,
  },
  counterButton: {
    paddingHorizontal: 12,
    paddingBottom: 2,
    borderWidth: 1,
    borderColor: colors.brandPrimary,
    borderRadius: 30,
    backgroundColor: colors.white,
  },
  hovered: {
    backgroundColor: colors.hover,
  },
});

export default styles;
